export class Width {
  public static DEFAULT_EDGE: string = '3px';
  public static UNDERLAY_EDGE_BORDER_WIDTH: string = '6px';
  public static UNDERLAY_NODE_BORDER_WIDTH: string = '8px';
}
